
import { reactive } from 'vue';
import { defineStore } from 'pinia';
import { ApiService } from 'src/services/api';
import { StorageService } from '../services/storage';
export const useAuthStore = defineStore('auth', () => {
	const state = reactive({
		user: null,
		userRole: '',
		userPages: [],
	});

	function normalizeLocale(locale) {
		if (!locale) {
			return '';
		}
		if (locale === 'pt_PT' || locale === 'pt-PT') {
			return 'pt';
		}
		if (locale === 'en_US' || locale === 'en-US') {
			return 'en-US';
		}
		if (locale === 'es_ES' || locale === 'es-ES') {
			return 'es-ES';
		}
		return locale;
	}

	function getClientPreferredLocale() {
		return StorageService.getLocale() || 'pt';
	}

	function getLoginToken() {
		let token = StorageService.getToken() || null;
		return token;
	}

	async function getUserData() {
		try {
			// Mantém o locale da aplicação salvo no LocalStorage
			const currentLocalLocale = getClientPreferredLocale();
			StorageService.setLocale(currentLocalLocale);
			const response = await ApiService.get("account/currentuserdata");
			const userData = response.data;

			state.user = userData.user || null;
			state.userPages = userData.pages || [];

			const roles = userData.roles || []
			state.userRole = roles.toString();

			// a var currentLocalLocale já foi obtida no início da função
			const backendLocaleRaw = state.user?.locale || '';
			const userLocale = normalizeLocale(backendLocaleRaw);

			if (state.user && userLocale !== currentLocalLocale) {
				try {
					await ApiService.post('account/locale', { locale: currentLocalLocale });
				} catch (e) {
					console.error('Falha ao sincronizar locale no backend', e);
				}
			}

			StorageService.setLocale(currentLocalLocale);
			if (state.user) {
				state.user.locale = currentLocalLocale;
			}

		}
		catch (err) {
			throw err;
		}
	}

	async function login ( args){
		try {
			const { url, formData, rememberUser } = args;
			const response = await ApiService.post(url, formData);
			const loginData = response.data;
			saveLoginData( { loginData, rememberUser });
			return loginData;
		}
		catch (err) {
			throw err;
		}
	}

	async function saveLoginData (args) {
		const { loginData, rememberUser } = args;
		if(loginData?.token){
			StorageService.saveLoginData(loginData, rememberUser);
		}
	}

	async function saveRecord (args) {
		try {
			const { url, payload } = args;
			const response = await ApiService.post(url, payload);
			const record = response.data;
			return record;
		}
		catch (err) {
			throw err;
		}
	}

	async function logout () {
		// Remove the token and remove Authorization header from Api Service as well
		StorageService.removeLoginData();
		ApiService.removeHeader();
	}

	return {
		state,
		saveLoginData,
		getLoginToken,
		getUserData,
		login,
		logout,
		saveRecord,
	}
});
